import { render } from "./TripSchedule.vue?vue&type=template&id=519e2da2"
import script from "./TripSchedule.vue?vue&type=script&lang=js"
export * from "./TripSchedule.vue?vue&type=script&lang=js"
script.render = render

export default script